"use strict";function fetchData$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.fetchData$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.intent.fetchData";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.7.6"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.7.6"},_a)),exports.fetchData$=fetchData$,exports.default=fetchData$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/intent/fetchData.js
// module id = 954
// module chunks = 106